<template>
    <div>
        <b-row>
            <b-col lg="7">
                <p>Only JPG, PNG and PDF accepted. Max file size is 1 MB.</p>
            </b-col>
            <b-col lg="3">
                <div class="upload-file-container" v-if="filesList.length <= 0">
                    <input type="file"
                           @change="uploadFiles"
                           name="upload_files"
                           multiple>
                    <button type="button"
                            class="button--primary">Upload files</button>
                </div>
                <div class="upload-file-container" v-if="filesList.length > 0">
                    <button type="button"
                            class="button--primary"
                            @click="removeFiles()">Remove files</button>
                </div>
            </b-col>
        </b-row>
        <b-row v-for="(value, index) in filesList"
               :key="index"
               class="uploaded-file">
            <b-col lg="7" class="uploaded-file-container">
                <p>{{ value.name ? value.name : '' }}</p>
                <img :src="value.url ? value.url : ''" alt="">
            </b-col>
        </b-row>
        <b-row v-if="filesList.length > 0" style="margin-top: 30px;">
            <b-col lg="7"></b-col>
            <b-col lg="3" class="uploaded-file-action">
                <button class="button--primary"
                        type="button"
                        @click="confirmFiles()" v-if="!progress">Confirm</button>
                <button class="button--primary button--progress"
                        type="button"
                        v-if="progress">Confirm</button>
            </b-col>
        </b-row>

    </div>

</template>

<script>
    export default {
        dependencies: ['popup', 'verification'],
        data () {
            return {
                filesList: [],
                progress: false
            }
        },
        methods: {
            uploadFiles (e) {
                let files = e.target.files || e.dataTransfer.files;

                if (!files.length) return;
                for (const file in files) {
                    if (typeof files[file] === 'object') {
                        let extensions = ['image/png', 'image/jpg', 'image/jpeg'];
                        if (extensions.indexOf(files[file].type) === -1) {
                            this.popup.show('Only JPG and PNG accepted.');
                        }
                        else if ((files[file].size/1024)/1024 > 1) {
                            this.popup.show('Max file size is 1 MB.');
                        }
                        else {
                            this.createImage(files[file], file);
                        }

                    }
                }
            },
            createImage (file, index) {
                let reader = new FileReader(),
                    vm = this;

                reader.onload = function (e) {
                    vm.$set(vm.filesList, index, {
                        url: e.target.result,
                        name: file.name,
                        progress: false
                    });
                };

                reader.readAsDataURL(file);
            },
            removeFiles () {
                this.filesList = [];
            },
            confirmFiles () {
                this.progress = true;

                let filesToUpload = [];

                for (let fileId in this.filesList) {
                    filesToUpload.push(this.filesList[fileId].url);
                }

                this.verification.sendFiles(filesToUpload).then(() => {
                    this.filesList = [];
                    this.progress = false;
                    this.verification.loadVerificationFiles();
                }, () => {
                    this.progress = false;
                })
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../../assets/scss/_colors.scss';

    .upload-file{
        margin-bottom: 11px;
    }

    .upload-file-container{
        position: relative;

        input[type="file"]{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            z-index: 2;
            opacity: 0;
            cursor: pointer;
        }

        button{
            display: block;
            width: 100%;
        }

        &:hover,
        &:focus{
            .button--primary{
                background-color: darken($base1, 10%);
            }
         }
    }

    .uploaded-file{
        +.uploaded-file{
            margin-top: 11px;
        }
    }

    .uploaded-file-container{
        img{
            max-width: 60%;
        }
    }

    .uploaded-file-action{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    @media (max-width: 991px) {
        .upload-file-container{
            margin: 11px 0;

            button{
                width: auto;
            }
        }

        .uploaded-file-action{
            display: block;
            margin: 11px 0;
        }
    }

    @media (max-width: 475px) {
        .upload-file-container,
        .uploaded-file-action{
            button{
                width: 100%;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/verification/UploadFiles.vue